/** pt-BR copy for Portaria (final copy from the handoff, plus the code-first and storage additions). */
export const deskStrings = {
  title: 'Portaria',
  subtitle:
    'Tudo que aguarda uma unidade é uma retirada com um código. Registre a entrega como unidade + transportadora — sem descrições para digitar.',
  guestArrived: 'Visitante chegou',
  registerDeliveries: 'Registrar entregas',
  searchPlaceholder: 'Unidade, morador ou transportadora',
  tabsLabel: 'Filtro da portaria',
  loadError: 'Não foi possível carregar a portaria',
  loadErrorHint: 'Verifique sua conexão e tente de novo.',
  retry: 'Tentar de novo',

  empty: {
    waiting: { title: 'Nada aguardando', description: 'Tudo que chegou já foi entregue.' },
    expected: {
      title: 'Nenhum visitante esperado',
      description: 'Os moradores pré-cadastram visitantes no app e eles aparecem aqui.',
    },
    history: {
      title: 'Nada entregue ainda',
      description: 'Retiradas e entradas confirmadas aparecem aqui.',
    },
  },

  codeLookup: {
    title: 'Retirada por código',
    description:
      'Digite o código que o morador mostra no app para abrir a retirada ou a entrada direto.',
    label: 'Código do morador',
    invalid: 'O código não confere. Peça ao morador para reabrir a retirada no app.',
    used: 'Este código já foi usado.',
    failed: 'Não foi possível verificar o código. Tente de novo.',
  },

  handover: {
    codeHint:
      'Seis caracteres, exibidos no app do morador. Um código libera tudo que está aguardando para a unidade.',
    verified: 'Código confirmado. Confira os dados e libere.',
    confirmItems: 'Confirmar retirada',
    confirmGuest: 'Confirmar entrada',
    failed: 'Não foi possível confirmar agora. Tente de novo.',
  },

  register: {
    title: 'Registrar entregas',
    addToPickup: (unit: string) => `Adicionar à retirada da unidade ${unit}`,
    carrier: 'Transportadora',
    addUnit: 'Adicionar outra unidade',
    queueHint: 'Continue enquanto o entregador descarrega — tudo é registrado de uma vez.',
    noResident: 'Esta unidade não tem morador vinculado — ninguém será avisado.',
    prefillHint:
      'O que você adicionar entra na mesma retirada. O código que o morador já tem continua valendo — ele retira tudo de uma vez.',
    storageTitle: 'Onde fica guardado',
    slotLabel: 'Compartimento',
    slotPlaceholder: 'Nº do compartimento',
    storageHint: 'Vale para tudo que está sendo registrado nesta janela.',
    photosTitle: 'Fotos',
    photosOptional: 'opcional',
    photosHint: 'Ajuda o morador a reconhecer o que chegou. Fotografe a etiqueta ou a embalagem.',
    addPhoto: 'Adicionar foto',
    submitFailed: 'Não foi possível registrar tudo. Confira a lista e tente de novo.',
    uploadFailed: 'Não foi possível enviar as fotos. Tente de novo.',
  },

  visitor: {
    title: 'Registrar chegada de visitante',
    name: 'Nome do visitante',
    namePlaceholder: 'Paula Rocha',
    document: 'Documento',
    documentPlaceholder: '321.998.774-10',
    documentHint: 'Opcional — fica no registro da chegada.',
    expectedHere: 'Esperados para esta unidade',
    note: 'O morador recebe no app um código de entrada de seis caracteres. Ele nunca é mostrado ao visitante.',
    submit: 'Registrar chegada',
    failed: 'Não foi possível registrar a chegada. Tente de novo.',
  },

  unitPad: {
    label: 'Unidade',
    placeholder: 'Digite o número da unidade ou o morador',
    none: (q: string) => `Nenhuma unidade corresponde a “${q}”.`,
    loading: 'Carregando unidades',
  },
}
